<button
    [id]="id"
    type="button"
    [attr.aria-pressed]="selected"
    class="agpr-vi-question-card agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-vi-question-card--selected': selected,
    }"
    (click)="selectChange.emit(!selected)"
>
    <div class="agpr-vi-question-card-group">
        <span
            class="agpr-vi-question-card-activeBar"
            [style.opacity]="selected ? 1 : 0"
        ></span>

        <div class="agpr-vi-question-card-col">
            <span
                class="agpr-vi-question-card-text"
                [ngClass]="{
                    'agpr-vi-question-card-text--error': !question?.trim(),
                }"
            >
                {{ question?.trim() || ('VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.question.error' | localize) }}
            </span>
            @if (showDimention) {
                <span class="agpr-vi-question-card-text-sub">
                    {{  'VisibilityIntelligence.querySetup.dimensions.' + dimension | localize }}
                </span>
            }
        </div>
    </div>

    @if (hasError) {
        <span
            role="img"
            class="agpr-vi-question-card-errorIcon fa-solid fa-circle-minus"
            [aria-hidden]="true"
        ></span>
    }

    @if (showMetrics) {
        <div class="agpr-vi-question-card-metrics">
            <span
                class="agpr-vi-question-card-metrics-score"
                [agprTooltip]="score === null ? 'Vi.questionCard.score.error.tooltip' : ''"
            >
                {{ score ?? '—' }}
            </span>

            @if (delta | isNumber) {
                <div
                    class="agpr-vi-question-card-metrics-bubble"
                    [ngClass]="{
                        'agpr-vi-question-card-metrics-bubbleRed': inverseArrows ? delta > 0 : delta < 0,
                        'agpr-vi-question-card-metrics-bubbleGreen': inverseArrows ? delta < 0 : delta > 0,
                        'agpr-vi-question-card-metrics-bubbleGrey': delta === 0,
                    }"
                >
                    @if (delta === 0) {
                        <span
                            aria-hidden="true"
                            agprTooltip="Vi.questionCard.delta.noChange.tooltip"
                        >
                            --{{inverseArrows ? '' : '%'}}
                        </span>
                    } @else {
                        <span
                            class="fa-regular"
                            [ngClass]="{
                                'fa-arrow-down-right': inverseArrows ? delta > 0 : delta < 0,
                                'fa-arrow-up-right': inverseArrows ? delta < 0 : delta > 0,
                            }"
                            aria-hidden="true"
                        ></span>
                        <span aria-hidden="true">{{ delta | abs }}{{inverseArrows ? '' : '%'}}</span>
                    }
                </div>
            } @else {
                <div class="agpr-vi-question-card-metrics-bubble agpr-vi-question-card-metrics-bubbleGrey">
                    <span
                        aria-hidden="true"
                        agprTooltip="Vi.questionCard.delta.error.tooltip"
                    >
                        {{ 'Common.not.available' | localize }}
                    </span>
                </div>
            }
        </div>
    }

    @if (allowDelete) {
        <div class="agpr-contextMenu bottom right">
            <agpr-button
                [id]="id + '_deleteButton'"
                [style]="buttonType.contextMenu"
                icon="fa-regular fa-duotone fa-trash-can"
                tooltip="VisibilityIntelligence.querySetup.reviewQuestion.deleteAction"
                tooltipPosition="right"
                (click)="$event.stopPropagation(); deleteRequested.emit(true)"
            ></agpr-button>
        </div>
    }
</button>
